import { createSvgIcon } from "@mui/material";

export const AlignTopIcon = createSvgIcon(
  <svg viewBox="0 0 9 14" fill="none">
    <path
      fill="currentColor"
      d="M7.805 0a.61.61 0 0 1 .633.633.625.625 0 0 1-.633.633H4.852v11.367a.633.633 0 1 1-1.266 0V1.266H.633A.64.64 0 0 1 0 .633C0 .263.29 0 .633 0z"
    />
  </svg>,
  "AlignTopIcon",
);
